import axios from 'axios';
import { store } from '../store/store';
import { logout } from '../store/slices/authSlice';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth.token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Attach exact GPS location if user granted permission
    const adminLocation = localStorage.getItem('adminLocation');
    if (adminLocation) {
      try {
        const coords = JSON.parse(adminLocation);
        if (coords.lat && coords.lon) {
          config.headers['X-Client-Location'] = `${coords.lat},${coords.lon}`;
        }
      } catch (e) {}
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export default api;
